export const reservas = {
    // Filtro con el que llega el listado desde las cajas del dashboard
    filtroLlegadas: {
        today: `Arriving today`,
        tomorrow: `Arriving tomorrow`,
        this_week: `Arriving this week`,
        month: `Arriving this month`,
        upcoming: `Upcoming arrivals`,
    },
    filtroSalidas: {
        today: `Leaving today`,
    },
    quitarFiltro: `Remove filter`,
    // Estancia vendida por horas registrada como reserva
    rapida: `Quick`,
    p1:`Booking list`,
    p2:`List of bookings registered on the platform`,
    p3:`More actions`,
    p4:`Schedule Check-in`,
    p5:`Today`,
    p6:`Booking code`,
    p7:`First name`,
    p8:`Email`,
    p9:`Check-in date`,
    p10:`Deposit`,
    p11:`Number of guests`,
    p12:`Status: `,
    p13:`Amount: `,
    p14:`Status: `,
    p15:`Pending`,
    p16:`Complete`,

    p17:`More actions`,
    p18:`Import bookings`,
    p19:`Download an Excel template, fill in your booking data and upload it to create multiple bookings at once.`,

    p20:`Scheduled Check-in`,
    p21:`Detailed information of the scheduled check-in`,
    p22:`Status: `,
    p23:`Paid`,
    p24:`Pending payment`,
    p25:`Change payment status`,
    p26:`Check-in responsible`,
    p27:`Send online check-in`,
    p28:`Sending check-in link...`,
    p29:`Send online check-in link to guests automatically`,
    p30:`One week before check-in`,
    p31:`72 hours before check-in`,
    p32:`48 hours before check-in`,
    p33:`24 hours before check-in`,
    p34:`Save changes`,
    p35:`Check-in date`,
    p36:`Check-out date`,
    p37:`Registered guests`,
    p38:`List of completed check-ins`,
    p39:`First name`,
    p41:`Last name`,
    p42:`Check-in date`,
    p43:`Email`,
    p44:`Process`,
    p45:`Scanned`,
    p46:`Manual`,
    p47:`Operator manual`,
    p48:`Phone`,
    p49:`No check-ins registered`,

    p50:`Booking payment status`,
    p51:`Manually change the booking payment status.`,
    p52:`Select one of the options`,
    p53:`Pending`,
    p54:`Paid`,
    p55:`Cancel`,
    p56:`Change status`,
    p57:`Unspecified`,
    p58:`Complete`,
    p59:`No bookings registered yet`,
    p60:`Scheduled check-ins`,
    p61:`Changes saved successfully`,
    p62:`Do you want to send the check-in link?`,
    p63:`Send link`,
    p64:`Cancel`,
    p65:`Check-in request sent successfully`,

    p66:`Property or user not found.`,
    p67:`Error generating token`,
    p68:`Error connecting to the channel. Please try again.`,
    p69:`Availability & Rates`,
    p70:`Manage available days and rates in your accommodation`,
    p71:`To activate this feature, you need an active plan. You’ll be able to instantly see your accommodation’s availability, adjust rates according to season or special events, and manage everything from one place.`,
    p72:`By cancelling this booking, the dates will become available on any connected portal`,
    p73:`Cancel booking`,
    p74:`Booking cancelled successfully`,
    p75:`Booking of `,
    p76:` cancelled.`,
    p77:`You cannot book on blocked dates.`,
    p78:`Check selected dates`,
    p79:`You must select at least one night for the booking.`,
    p80:`Selected dates are not available.`,
    p81:`Reminders`,
    p82:`Manage reminders for your guests`,
    p83:`Create new reminder`,
    p84:`Day`,
    p85:`Time`,
    p86:`Description`,
    p87:`Delete reminder`,
    p88:`No reminders found`,
    p89:`Are you sure you want to delete the reminder?`,
    p90:`You will lose saved data`,
    p91:`Delete reminder`,
    p92:`Reminder deleted successfully`,
    p93:`First step:`,
    p94:`Select the country where you have bookings and download the template to fill in the data.`,
    p95:`Download template`,
    p96:`Second step:`,
    p97:`Upload the same template(s) you downloaded with the data added.`,
    p98:`Import`,
    p99:`You must upload the template to continue with the import`,
    p100:`Process completed successfully`,
    p101:`Error during import process`,
    p102:`Available`,
    p103:`Occupied`,
    p104:`Cleaning`,
    p105:`Maintenance`,
    p106:`Error cancelling the booking`,
    p107:`Error updating the view after cancellation`,
    p108:`Could not open room change. Invalid booking.`,
    p109:`Could not identify current room.`,
    p110:`Availability updated successfully`,
    p111:`Hotel Calendar`,
    p112:`Manage your bookings visually and keep full control of your hotel's availability.`,
    p113:`Change availability`,
    p114:`Create booking`,
    p115:`Paused bookings will not be sent automatically`,
    p116:`Automatic sending will be enabled for this booking`,
    p117:`Pause`,
    p118:`Activate`,
    p119:`the booking`,
    p120:`Yes`,
    p121:`Booking paused successfully`,
    p122:`Process completed successfully`,
    p123:`Booking activated successfully`,
    p124:`Synced and manually created bookings`,
    p125:`Invalid date`,
    p126:`Invalid Date`,
    p127:`Check-in invitation will be sent on `,
    p128:`Booking paused`,
    p129:`Booking cancelled`,
    p130:`Complete`,
    p131:`All your bookings with each check-in and guest details will appear here. When you receive your first booking, you’ll see it right here.`,
    p132:`Selected property`,
    p133:`Multiple`,
    p134:`Monthly`,
    p135:`Closed`,
    p136:`Dates updated successfully`,
    p137:`Error loading property data`,
    p138:`Selected dates are not available. There are bookings or closed dates causing a conflict.`,
    p139:`Booking created successfully`,
    p140:`Range`,
    p141:`closed successfully`,
    p142:`Error blocking dates`,
    p143:`Error removing closed dates`,
    p144:`Prices updated successfully`,
    p145:`Error updating prices`,
    p146:`Are you sure you want to cancel this booking?`,
    p147:`Confirm cancellation`,
    p148:`Yes, cancel`,
    p149:`No`,
    p150:`Booking cancelled successfully`,
    p151:`Error loading properties`,
    p152:`New booking added to calendar`,
    p153:`This booking comes from an external channel (OTA). It is not recommended to cancel it directly from this system. Please contact the guest and ask them to cancel the booking through the original channel.`,
    p154:`OTA Booking - Cancellation not allowed`,
    p155:`Understood`,
    p156:`Error processing request`,
    p157:`Link copied successfully`,
    p158:`Copied!`,
    p159:`There was an error copying the link`,
    p160:`Error`,
    p161:`Send check-in to booking responsible`,
    p162:`Send check-in`,
    p163:`Send`,
    p164:`Error loading booking`,
    p165:`Check-in information`,
    p166:`Send check-in request`,
    p167:`All bookings`,
    p168:`Upcoming bookings`,
    p169:`Cancelled bookings`,
    p170:`Guests`,
    p171:`Check-in date`,
    p172:`Check-in`,
    p173:`Booked`,
    p174:`Overbooking`,
    p175:`Cancelled`,
    p176:``,
    p177:``,
    p178:``,
    p179:``,
    p180:``,
    p181:``,
    p182:``,
    p183:``,
}
